import React, { useState, useCallback, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Divider, Row, Col, Table, Button, Space, Tag, Tooltip, notification,Modal, List, Card, Empty, Typography, Spin} from 'antd';
import { LeftOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import CreateAssignment from './create-assignment-modal';
import DeleteConfirmation from './delete-confirm-modal';
import EditAssignment from './edit-assignment-modal';
import htmlLogo from "../../assets/images/HTML.svg";
import vcJrLogo from "../../assets/images/vc jr logo.png";
import sqlLogo from "../../assets/images/sqlLogo.png";
import pythonLogo from "../../assets/images/pythonLogo.png";
import classIcon from "../../assets/logos/Class.svg";
import calenderIcon from "../../assets/logos/Calender.svg";
import chalkboardIcon from "../../assets/logos/chalkboard-teacher.svg";
import { fetchLabQuestion, deleteResources } from '../../services/ide-apis';
import { global_var } from '../../services/cs-lab-config';
import { trackEvent, formatDate, formatDateMonth } from '../utils/util-functions';
import ProjectFilters from '../utils/project-filters';
import ModalComponent from '../labAssignments/assignment-details-modal';
import  noDataImage  from '../../assets/images/No notifcations.png'
import { ReactComponent as EditIcon } from '../../assets/logos/lab edit icon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/logos/delete icon.svg';
import { ReactComponent as ReportIcon } from '../../assets/logos/assignment report.svg';

const { Meta } = Card;

const AssignmentList = () => {
  document.title = 'CS Lab | Assignment';


  const [visible, setVisible] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [deleteConfirmationVisible, setDeleteConfirmationVisible] = useState(false);
  const [labQuestions, setLabQuestions] = useState([]);
  const [removeFromAssignedStudents, setRemoveFromAssignedStudents] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [totalProjectsCount, setTotalProjectsCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState([]);
  const [labQuestionLoading, setLabQuestionLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [currentFilters, setCurrentFilters] = useState({});

  useEffect(() => {
    if (!location.state?.fromAssignmentList) {
      sessionStorage.removeItem("labAssignmentFilters");
    }
  }, [location.state]);

  const showModal = () => {
    trackEvent("assign_lab_assignment_button_clicked",{});
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
    setIsOpen(false);
  };
  const projectTypeLabelMap = {
    python: "Python",
    html_css: "HTML",
    vc3: "Scratch",
    sql2: "SQL",
  };
  
  const handleCreate = (values, stage) => {
    if (stage === 'create') {
        // Add logic to handle the creation of a new assignment
        let newAssignment = {
            "_id": values._id,
            "title": values.questionTitle ? values.questionTitle : values.aiQuestionTitle,
            // "projectType": values.projectType ? values.projectType : values.aiProjectType,
            "teacherName": global_var.user_name,
            "createdDate": values.createdDate,
            "totalEvaluatedCount": 0,
            "totalCompletedCount": 0,
            "totalAssignedCount": values.totalAssignedCount,
            "assignTo": values.assignTo,
            "elements" : values.elements,
            "totalMark" : values.maximumMark ? values.maximumMark : values.aiMaximumMark,
            "projectType" : values.projectType ? values.projectType : values.aiProjectType,
            "labQuestionsMappingId":values.labQuestionsMappingId,
            "dueDate":values.dueDate,
            "fkResourceStudentLevelId":values.fkResourceStudentLevelId,
            "resourceStudentLevelName":values.resourceStudentLevelName,
            "resourceStudentLevelColor":values.resourceStudentLevelColor
        };
        setLabQuestions((prevLabQuestions) => [newAssignment, ...prevLabQuestions]);
    } else if (stage === 'edit') {
        // Add logic to handle the update of an existing assignment
        setLabQuestions((prevLabQuestions) => {
            return prevLabQuestions.map((labQuestion) => {
              if (labQuestion.labQuestionsMappingId === values.labQuestionsMappingId) {
                    // Update the assignment with matching _id
                    return {
                        ...labQuestion,
                        "title": values.questionTitle,
                        "projectType": values.projectType,
                        "totalAssignedCount": values.totalAssignedCount?values.totalAssignedCount:labQuestion.totalAssignedCount,
                        "assignTo": values.assignTo,
                        "teacherName": global_var.user_name,
                        "elements" : values.elements,
                        "dueDate":values.dueDate,
                        "totalMark" : values.maximumMark,
                        "fkResourceStudentLevelId":values.fkResourceStudentLevelId,
                        "resourceStudentLevelName":values.resourceStudentLevelName,
                        "resourceStudentLevelColor":values.resourceStudentLevelColor
                    };
                }
                return labQuestion;
            });
        });
    }

    setVisible(false);
};

  const isSupervisor = (record) => {
    if ( global_var.role_id === global_var.SUPERVISOR_ROLE_ID || global_var.role_id === global_var.SUPERVISOR_ROLE_IDS) {
      return global_var.roleMappingId !== record.crmId;
    }
    return false;
  };

  const filtersChanged = useCallback(async (filters) => {
    setCurrentFilters(filters);
    try {
      setLabQuestionLoading(true);
      let requestObj = {
        ...filters,
        "companyId": global_var.company_id,
        limitCount: 12,
        from: "csLab"
      };
      requestObj.pageNo = requestObj.pageNo - 1;
      
      if (global_var.role_id !== global_var.ADMIN_ROLE_ID && global_var.role_id !== global_var.SYSTEMUSER_ROLE_ID && global_var.role_id !== global_var.SUPERVISOR_ROLE_ID && global_var.role_id !== global_var.SUPERVISOR_ROLE_IDS) {
        requestObj['fkUserLoginId'] = global_var.user_login_id;
      }
  
      const response = await fetchLabQuestion(requestObj);
      if (response.data.statusCode === 200) {
        setTotalProjectsCount(response.data.totalProjectsCount);
        setLabQuestions(response.data.labQuestions);
      } else {
        console.error("Failed to fetch lab questions:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching lab questions:", error);
    }finally{
      setLabQuestionLoading(false);
    }
  }, [setLabQuestions]);


  const columns = [
    {
      title: 'Question Details',
      dataIndex: 'title',
      key: 'activityName',
      render: (_, record) => {
        const subject = record.projectType ? projectTypeLabelMap[record.projectType] : '';
        const isHTML = record.projectType === 'html_css';
        const isVC3 = record.projectType === 'vc3';
        const isPython = record.projectType === 'python';
        const isSQL = record.projectType === 'sql2';

        // Assigned To logic
        let assignedTo = '';
        if (record.assignTo && record.assignTo.length > 0) {
          let assignments = [];
    
          // Loop through all assignments
          record.assignTo.forEach((assignment) => {
            if (assignment.type === 'class-division') {
              const { className, divisionName, streamName } = assignment;
              assignments.push(`${className || ''} ${divisionName || ''}${streamName ? ` ${streamName}` : ''}`);
            } else if (assignment.type === 'batches') {
              assignment.batches?.forEach((b) => assignments.push(b.batchName));
            } else if (assignment.type === 'groups') {
              assignment.groups?.forEach((g) => assignments.push(g.groupFullName));
            } else if (assignment.type === 'individual-students') {
              assignment.individualStudents?.forEach((s) => assignments.push(s.Name));
            }
          });
    
          if (assignments.length > 0) {
            const fullText = assignments.join(', ');
            const truncatedText = fullText.length > 25 ? fullText.substring(0, 25) + '...' : fullText;
    
            assignedTo = (
              <Tooltip title={fullText}>
                <span style={{ cursor: 'pointer' }}>{truncatedText}</span>
              </Tooltip>
            );
          }
        }   
        let subjectLogo = null;
        if (isHTML) subjectLogo = htmlLogo;
        else if (isVC3) subjectLogo = vcJrLogo;
        else if (isSQL) subjectLogo = sqlLogo;
        else if (isPython) subjectLogo = pythonLogo; 

        return (
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            {/* Left side: subject logo */}
            {subjectLogo && (
              <div
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  backgroundColor: '#f5f5f5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px',
                  flexShrink: 0,
                }}
              >
                <img src={subjectLogo} alt="subject logo" style={{ width: '35px', height: '35px' }} />
              </div>
            )}
    
            {/* Right side: text details */}
            <div style={{ flex: 1 }}>
              {/* Title */}
              <Tooltip title={`Click to view more information about ${record.title}`}>
                <label
                  style={{
                    cursor: 'pointer',
                    fontWeight: 600,
                    fontSize: '15px',
                    color: '#000',
                    display: 'inline-block',
                  }}
                  onClick={() => {
                    setSelectedProject(record);
                    setIsOpen(true);
                  }}
                >
                  {record.title}
                </label>
              </Tooltip>
    
              {/* Subject */}
              <div style={{ fontSize: '13px', color: '#666', marginBottom: '6px' }}>
                {subject}
              </div>
    
              {/* Teacher */}
              {record.teacherName && (
                <div style={{ fontSize: '13px', color: '#333', marginBottom: '2px' }}>
                  <img
                    src={chalkboardIcon}
                    alt="teacher icon"
                    style={{ width: '18px', height: '18px', marginRight: '6px' }}
                  />
                  {record.teacherName}
                </div>
              )}
    
              {/* Assigned To */}
              {assignedTo && (
                <div style={{ fontSize: '13px', color: '#333', marginBottom: '2px' }}>
                  <img
                    src={classIcon}
                    alt="class icon"
                    style={{ width: '18px', height: '18px', marginRight: '6px' }}
                  />
                  {assignedTo}
                </div>
              )}
    
              {/* Assigned Date */}
              {record.createdDate && (
                <div style={{ fontSize: '13px', color: '#333' }}>
                  <img
                    src={calenderIcon}
                    alt="calendar icon"
                    style={{ width: '18px', height: '18px', marginRight: '6px' }}
                  />
                  {formatDateMonth(record.createdDate)}
                </div>
              )}
            </div>
          </div>
        );
      },
    },    
    {
      title: 'Assigned',
      dataIndex: 'totalAssignedCount',
      key: 'assigned',
      render: (assigned) => <Tag className='assigned-tag'>{assigned}</Tag>,
    },
    {
      title: 'Submitted',
      dataIndex: 'totalCompletedCount',
      key: 'completed',
      render: (completed) => <Tag className='completed-tag'>{completed}</Tag>,
    },
    {
      title: 'Evaluated',
      dataIndex: 'totalEvaluatedCount',
      key: 'evaluated',
      render: (evaluated) => <Tag className='evaluated-tag'>{evaluated}</Tag>,
    },

    {
      title: 'AI Generated',
      dataIndex: '',
      key: 'AIGenerated',
      render: (_, record) => {
        if (isSupervisor(record)) {
          return (
            <span>
              <Tooltip title="You are not authorized to perform this action">
                <Button style={{backgroundColor:'#E5E3E3',borderColor: "#fff"}} disabled>
                  Auto Evaluate
                </Button>
              </Tooltip>
            </span>
          )
        }
      return (
        <span>
         <Tooltip
          title={
            record.totalCompletedCount === 0
              ? 'No student submissions to evaluate'
              : (record.totalEvaluatedCount === record.totalCompletedCount ? 'No pending evaluation' : '')
          }
        >
          {record.totalCompletedCount === 0 || record.totalEvaluatedCount === record.totalCompletedCount ?  (
            <Button
            onClick={() => handleAutoEvaluate(record)}
            id="assignment-auto-evaluate-disabled"
            data-testid="assignment-auto-evaluate-disabled"
            style={{backgroundColor:'#E5E3E3',borderColor: "#fff"}}
            disabled
            >Auto Evaluate</Button>
          ) : (
            <Button className='create-button'
              id="assignment-auto-evaluate"
              data-testid="assignment-auto-evaluate"
              onClick={() => handleAutoEvaluate(record)}
              style={{color:'#fff',borderColor: "#E96358"}}
            >
              Auto Evaluate
            </Button>
          )}
        </Tooltip>
      </span>
      )}
    },


    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      render: (_, record) => {
        if (isSupervisor(record)) {
          return (
            <span>
              <Tooltip title="You are not authorized to perform this action">
                <Button style={{backgroundColor:'#E5E3E3',borderColor: "#fff"}} disabled>
                  Manual Evaluate
                </Button>
              </Tooltip>
            </span>
          )
        }
      return (
        <span>
        <Tooltip
          title={
            record.totalCompletedCount === 0
              ? 'No student submissions to evaluate'
              : (record.totalEvaluatedCount === record.totalCompletedCount ? 'No pending evaluation' : '')
          }
        >
          {record.totalCompletedCount === 0  ? (
            <Button
            onClick={() => handleEvaluate(record)}
            id="assignment-manual-evaluate-disabled"
            data-testid="assignment-manual-evaluate-disabled"
            style={{backgroundColor:'#E5E3E3',borderColor: "#fff"}}
            disabled
            >Manual Evaluate</Button>
          ) : (
            <Button className='create-button'
            id="assignment-manual-evaluate"
            data-testid="assignment-manual-evaluate"
            onClick={() => handleEvaluate(record)}
            style={{color:'#fff',borderColor: "#E96358"}}
            >Manual Evaluate</Button>
          )}
        </Tooltip>
      </span>
      )}
    },
    {
      render: (_, record) => (
        <Space size="middle">
          {!global_var.teacherAccessRestricted && (
            <Tooltip title={
              isSupervisor(record) ? 'You are not authorized to edit' : 'Edit'
              }
            >
              <Button
                style={{color:'black'}}
                type="link"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
                disabled={isSupervisor(record)}
              />
            </Tooltip>
          )}
          <Tooltip title={'Report'}>
            <ReportIcon
              onClick={() => handleReport(record)}
              style={{cursor:'pointer'}}
            >
            </ReportIcon>
          </Tooltip>
                    <Tooltip title={
            isSupervisor(record)
              ? 'You are not authorized to delete'
              : 'Delete'
            }
          >
            {!global_var.teacherAccessRestricted && (
            <Button
              style={{color:'black'}}
              type="link"
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record)}
              disabled={isSupervisor(record)}
            />
          )}
          </Tooltip>
        </Space>
      ),
    },

  ];

  // Conditionally remove the 'Teacher' column if role_id is global_var.ADMIN_ROLE_ID
  // if (global_var.role_id !== global_var.ADMIN_ROLE_ID && global_var.role_id !== global_var.SUPERVISOR_ROLE_ID && global_var.role_id !== global_var.SUPERVISOR_ROLE_IDS) {
  //   const teacherColumnIndex = columns.findIndex((column) => column.key === 'teacher');
  //   columns.splice(teacherColumnIndex, 1);
  // }

  const handleEdit = (record) => {
    setEditRecord((prevRecord) => {
      // If the clicked record is different from the previous one, update the state
      if (prevRecord !== record) {
        return record;
      }
      
      return prevRecord;
    });
    setEditModalVisible(true);
  };

  const handleEditCancel = () => {
    setEditRecord(null);
    setEditModalVisible(false);
  };

  const handleEditAssignment = (editedData) => {
    // Implement logic to update the assignment with editedData
    // ...

    // Close the edit modal
    setEditModalVisible(false);
  };


  const handleDelete = (record) => {
    trackEvent("delete_lab_assignment_question_button_clicked",{});
    setDeleteRecord(record);
    setRemoveFromAssignedStudents(false);
    setDeleteConfirmationVisible(true);
  };
const handleConfirmDelete = async () => {
  if (deleteRecord.totalCompletedCount > 0) {
    Modal.confirm({
      title: <span style={{ fontSize: '18px', fontWeight: 'bold', color:'red' }}>Attention: Student Submission Exist !!</span>,
      content: (
        <div>
          <p style={{ fontSize: '16px' }}>
          It appears that students have submitted projects related to this question. If you proceed with deletion, both the question and the corresponding students submission will be permanently lost.
          </p>
          <p style={{ fontSize: '16px', fontWeight: 'bold', marginTop:'-15px'}}>
            Are you sure you want to proceed with the deletion?
          </p>
          <p style={{marginTop:'-15px'}}>This action cannot undone.</p>
        </div>
      ),
      onOk: async () => {
        await performDeleteAction();
      },
      onCancel: () => {
        setDeleteRecord(null);
        setRemoveFromAssignedStudents(false);
        setDeleteConfirmationVisible(false);
      },
      width: 500,
    });
  } else {
    // If no warning is needed, proceed with the delete action directly
    await performDeleteAction();
  }
};

const performDeleteAction = async () => {
  const deleteObj = {
    "resourceId": deleteRecord._id,
    "rmId": global_var.roleMappingId,
    "removeOnlyFromStudent": removeFromAssignedStudents,
    "mappingId": deleteRecord.labQuestionsMappingId
  };

  try {
    const deleteResponse = await deleteResources(deleteObj);
    if (deleteResponse.data.statusCode === 200) {
      const updatedLabQuestions = labQuestions.filter(item => item._id !== deleteRecord._id);
      setLabQuestions(updatedLabQuestions);

      notification.success({
        message: 'Success',
        description: deleteResponse.data.message,
      });
    } else {
      notification.error({
        message: 'Error',
        description: deleteResponse.data.message,
      });
    }
  } catch (error) {
    console.error('Error during delete action:', error);
  } finally {
    setDeleteConfirmationVisible(false);
    setRemoveFromAssignedStudents(false);
  }
};

function setActions(labQuestionsObj) {
  const actions = [];
  
  if (labQuestionsObj.totalCompletedCount === 0) {
    actions.push(<span>NA</span>);
  } else {
    actions.push(
      <Button
        id="assignment-manual-evaluate"
        data-testid="assignment-manual-evaluate"
        style={{ backgroundColor: '#E96358', color: '#fff', borderRadius: '10px', textAlign: 'left'  }}
        onClick={() => handleEvaluate(labQuestionsObj)}
      >
        Manual Evaluate
      </Button>
    );
  }

  if (labQuestionsObj.totalCompletedCount === 0 || labQuestionsObj.totalEvaluatedCount === labQuestionsObj.totalCompletedCount) {
    actions.push(<span>NA</span>);
  } else {
    actions.push(
      <Button
        id="assignment-auto-evaluate"
        data-testid="assignment-auto-evaluate"
        style={{ backgroundColor: '#E96358', color: '#fff', borderRadius: '10px', textAlign: 'left'  }}
        onClick={() => handleAutoEvaluate(labQuestionsObj)}
      >
        Auto Evaluate
      </Button>
    );
  }

  return actions;
}

  const handleCancelDelete = () => {
    setDeleteRecord(null);
    setRemoveFromAssignedStudents(false);
    setDeleteConfirmationVisible(false);
  };

  const handleEvaluate = (record) => {
    trackEvent("evaluate_lab_assignment_question_button_clicked",{});
    // Extract values from the record or any other source
    const labQuestionMappingId = record.labQuestionsMappingId;
    const resourceId = record._id;
    sessionStorage.setItem("labAssignmentFilters", JSON.stringify(currentFilters));
    navigate(`/evaluateprojects/${resourceId}/${labQuestionMappingId}`, { state: { fromAssignmentList: true } });
  };

  const handleAutoEvaluate = (record) =>{
    trackEvent("auto_evaluate_lab_assignment_button_clicked",{});
    const resourceId = record._id;
    const labQuestionMappingId = record.labQuestionsMappingId;
    sessionStorage.setItem("labAssignmentFilters", JSON.stringify(currentFilters));
    navigate(`/aiautobulkevaluate/${resourceId}/${labQuestionMappingId}`, { state: { fromAssignmentList: true } });
  }

  const handleReport = (record) =>{
    trackEvent("report_lab_assignment_button_clicked",{});
    const resourceId = record._id;
    const labQuestionMappingId = record.labQuestionsMappingId;
    sessionStorage.setItem("labAssignmentFilters", JSON.stringify(currentFilters));
    navigate(`/assignmentreport/${resourceId}/${labQuestionMappingId}`, { state: { fromAssignmentList: true } });
  }
  return (
    <>
      <Row className="mt-4">
        <Col className="col d-flex align-items-center" justify="space-evenly" align="middle">
          <Link to="/" className="mr-2">
            <span className="mt-2" style={{ backgroundColor: '#FFFFFF', padding: '5px', borderRadius: '5px', height:'35px', display: 'flex', alignItems: 'center'}}>
              <LeftOutlined className=" h4" style={{ color: '#000000' }} />
            </span>
          </Link>
          <span className="m-1 h4 ">Assignments</span>
        </Col>
        <Col>
          <Button id="assign-lab-question" data-testid="assign-lab-question" className='create-button' style={{color:'#fff',borderColor: "#E96358"}}  onClick={showModal}>
            Assign Lab Question
          </Button>
          <CreateAssignment visible={visible} onCancel={handleCancel} onCreate={handleCreate} hideClassFilter={global_var.needClass && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}
            hideDivisionFilter={global_var.needDivision && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true} hideStreamFilter={global_var.streamAvailable && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}/>
        </Col>
      </Row>
      <Divider className="mt-1" style={{backgroundColor:"#D7BEF7"}}/>
      <div className='row'>
      <ProjectFilters
        searchBoxPlaceHolder = "Search by lab questions"
        filtersChanged={filtersChanged}
        totalProjectsCount={totalProjectsCount}
        hideProjectStatusFilter = {true}
        hideClassFilter ={global_var.needClass && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}
        hideDivisionFilter ={global_var.needDivision && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}
        userSelectBoxPlaceHolder = "Search Question by trainer"
        userRoleIds = {global_var.TEACHER_ROLE_ID}
        hideUserFilter = {(global_var.role_id === global_var.ADMIN_ROLE_ID)? true : false}
        hideAcademicYearFilter = {(global_var.academicYearId)? false : true}
        hidePaginationTotalItems = {true}
        savedFiltersKey="labAssignmentFilters"
      />
      </div>
      <div className="row">
        <div className="col d-none d-md-block">
          <Table
            id="assignment-table"
            data-testid="assignment-table"
            dataSource={labQuestions}
            columns={columns}
            scroll={{ x: 'max-content' }}
            pagination={false}
            rowKey={(record) => record.labQuestionsMappingId}
            loading={labQuestionLoading}
          />
        </div>

  {/* Mobile View */}
        <div className="col d-md-none">
          {labQuestionLoading ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <Spin size="large" />
              <p className="mt-3 text-midgrey">Loading assignments…</p>
            </div>
          ) : labQuestions && labQuestions.length > 0 ? (
            <List
              grid={{
                gutter: 10,
                xs: 1,
                sm: 1,
              }}
              dataSource={labQuestions}
              renderItem={(labQuestionsObj) => (
                <List.Item>
                  <Card className="mobile-lab-assignment-card card-divider"
                    style={{backgroundClip:'#fff'}}
                     actions={setActions(labQuestionsObj)}>
                    <Meta
                      title={
                        <Typography.Text>
                         
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: '100%' }}>
                            <span className="poppins-regular" style={{
                              display: 'inline-block',
                              maxWidth: 'calc(100% - 48px)', // Adjusted width to accommodate icons
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              fontSize:'16px',
                            }}>
                              {labQuestionsObj.title}
                            </span>
                            <div style={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '48px' }}>
                              {!global_var.teacherAccessRestricted && (
                              <EditIcon style={{ marginLeft: '10px', cursor: 'pointer'}} onClick={() => handleEdit(labQuestionsObj)} />
                              )}
                              {!global_var.teacherAccessRestricted && (
                                <DeleteIcon style={{ marginLeft: '10px', cursor: 'pointer'}} onClick={() => handleDelete(labQuestionsObj)} />
                              )}
                              <ReportIcon style={{ marginLeft: '10px', cursor: 'pointer'}} onClick={() => handleReport(labQuestionsObj)} />
                            </div>
                          </div>   
                        </Typography.Text>
                      }
                      description={
                        <>
                          <div>
                            <p className='text-midgrey poppins-regular mt-3 mb-0' style={{ fontSize: '12px' }}>Assigned to: <span style={{ color: '#111111' }}> 
                              {labQuestionsObj.assignTo && labQuestionsObj.assignTo.length > 0 ? (
                                <>
                                  {labQuestionsObj.assignTo.map((assignment, index) => {
                                    const type = assignment.type;
                                    if (type === 'batches') {
                                      const batches = assignment.batches.map((batch) => batch.batchName);
                                      return <span key={index}>{batches.join(', ')}</span>;
                                    } else if (type === 'individual-students') {
                                      const students = assignment.individualStudents.map((student) => student.Name);
                                      return <span key={index}>{students.join(', ')}</span>;
                                    } else if (type === 'class-division') {
                                      const className = assignment.className;
                                      const divisionName = assignment.divisionName;
                                      const streamName = assignment.streamName;
                                      return <span key={index}>Class: {className}, Division: {divisionName}, {streamName && `, Stream: ${streamName}`}</span>;
                                    }

                                    return null; // Return null for unexpected types
                                  })}
                                </>
                              ) : null}
                            </span></p>
                            <p className='text-midgrey poppins-regular mb-2' style={{fontSize:'12px'}}>Assigned on:<span style={{color:'#111111'}}> {formatDate(labQuestionsObj.createdDate)}</span></p>
                          </div>
                          <div className='row'>
                            <div className='col-3'>
                              <span className='text-midgrey poppins-regular' style={{fontSize:'12px'}}>Evaluated:</span>
                              <p className='poppins-bold' style={{color:'#83C545',fontSize:'16px'}}>{labQuestionsObj.totalEvaluatedCount}</p>
                            </div>
                            <div className='col-3'>
                              <span className='text-midgrey poppins-regular' style={{fontSize:'12px'}}>Completed:</span>
                              <p className='poppins-bold' style={{color:'#2AC14E',fontSize:'16px'}}>{labQuestionsObj.totalCompletedCount}</p>
                            </div>
                            <div className='col-3'>
                              <span className='text-midgrey poppins-regular' style={{fontSize:'12px'}}>Assigned:</span> 
                              <p className='poppins-bold' style={{color:'#007AAB',fontSize:'16px'}}>{labQuestionsObj.totalAssignedCount}</p>
                            </div>
                          </div>
                        </>
                      }
                    />
                  </Card>
                </List.Item>
              )}
            />
          ) : (
            <Empty
              image={noDataImage}
              description={
                <div>
                  <p className="poppins-regular" style={{ fontSize: '18px' }}>No Projects yet!</p>
                </div>
              }
            />
          )}
        </div>

        <DeleteConfirmation
          open={deleteConfirmationVisible}
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
          questionName={deleteRecord ? deleteRecord.title : ''}
          removeFromAssignedStudents={removeFromAssignedStudents}
          setRemoveFromAssignedStudents={setRemoveFromAssignedStudents}
        />
        {editModalVisible && (
          <EditAssignment
            open={editModalVisible}
            onCancel={handleEditCancel}
            onEdit={handleEditAssignment}
            editRecord={editRecord}
            onCreate={handleCreate}
          />
        )}
        {isOpen && (
        <ModalComponent
          isOpen={isOpen}
          handleCancel={handleCancel}
          assignmentObj={selectedProject}
        />
        )}
      </div>
    </>
  );
};

export default AssignmentList;
